module.exports = __webpack_public_path__ + "img/banner_3.22e2ef6d.png";